<script setup lang="ts">
import { RouterView } from 'vue-router'

import SidebarComponent from '@/components/Navigation/SidebarComponent.vue'
</script>

<template>
  <SidebarComponent />
  <div class="main-layout-wrapper">
    <RouterView />
  </div>
</template>

<style lang="scss" scoped>
.main-layout-wrapper {
  min-height: 100vh;
  padding-left: 80px;
  padding-top: 72px;
}
</style>
